<template>
  <div class="min-h-screen flex items-center justify-center b px-2">
    <main class="w-full rounded-lg">
      <RouterView />
    </main>
  </div>
</template>
